import { Box, Typography, styled } from "@mui/material";
import NotFoundImage from "@/assets/search.svg"

export const NotFound: React.FC = () => {
    return (
        <Box sx={{ display: 'flex', flexDirection: 'column', justifyContent: 'center', alignItems: 'center', height: '80vh' }}>
            <Box component="img" src={NotFoundImage} alt="Search Icon" mb={2} />
            <Message>
                The page you’re looking for doesn’t exist.
            </Message>
        </Box>
    );
}

const Message = styled(Typography)(({ theme }) => ({
    ...theme.typography.body1,
    color: theme.palette.text.secondary,
    fontSize: "1.1rem",
    fontWeight: 600,
    letterSpacing: '0.5px'
}));
